export interface VariableComplexityPolicyModel {
  targetCardinalityThreshold: number;
  valueSizeThreshold: number;
  valueKeysThreshold: number;
  valueDepthThreshold: number;
  constraintOperatorsThreshold: number;
  constraintGroupsThreshold: number;
  changeFrequencyThreshold: number;
}

export const DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL: VariableComplexityPolicyModel =
  {
    targetCardinalityThreshold: 20,
    valueSizeThreshold: 20,
    valueKeysThreshold: 20,
    valueDepthThreshold: 4,
    constraintOperatorsThreshold: 4,
    constraintGroupsThreshold: 1,
    changeFrequencyThreshold: 10,
  };
